import { LiveChatWidget } from '@livechat/widget-react';
import { memo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from 'src/modules/locales/config';
import { useSettings } from 'src/modules/settings';

const CHAT_LICENSE = '16751010';
const LANGUAGE_GROUPS: Record<SupportedLanguages, string> = {
  en: '7',
  de: '202'
  // pl: '197',
  // ro: '213'
};

const _LiveChat = () => {
  const {
    chat: { chatComponentProps }
  } = useSettings();

  const {
    i18n: { language }
  } = useTranslation();

  const group = LANGUAGE_GROUPS[(language as SupportedLanguages) || 'en'];

  return (
    <ErrorBoundary
      fallback={null}
      onError={(error) => {
        console.log('[LIVECHAT ERROR]: ', error);
      }}>
      <LiveChatWidget
        license={CHAT_LICENSE}
        chatBetweenGroups={false}
        {...chatComponentProps}
        group={group}
      />
    </ErrorBoundary>
  );
};

export const LiveChat = memo(_LiveChat);
